<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>控股集团官网</el-breadcrumb-item>
      <el-breadcrumb-item>人力资源</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.tstype" placeholder="请选择" class="select"  style="width: 200px;">
               <el-option
                 v-for="item in tstypeList" :key="item.value" :label="item.label" :value="item.value">
               </el-option>
             </el-select>
            </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.title" @keyup.enter.native="clicksearch" placeholder="请输入新闻标题" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Id" label="编号" min-width="5%"></el-table-column>
          <el-table-column prop="Tstypes" label="类型" min-width="15%"></el-table-column>
          <el-table-column prop="Title" label="新闻标题" min-width="10%"></el-table-column>
          <el-table-column prop="Pic" label="图片" min-width="20%"></el-table-column>
          <el-table-column prop="Num1" label="在职人员" min-width="10%"></el-table-column>
          <el-table-column prop="Num2" label="研发人员" min-width="8%"></el-table-column>
          <el-table-column prop="Num3" label="生产基地" min-width="7%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="15%"></el-table-column>
          <el-table-column label="操作" min-width="10%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goEdit(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goDel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加">
        <el-form :model="addData" ref="addDataRef" label-width="110px">
          <el-form-item label="类型">
            <el-select v-model="addData.tstype" placeholder="请选择" class="select">
              <el-option
                v-for="item in tstypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标题" class="addAdminForm">
            <el-input v-model="addData.title" placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item label="图片" class="addAdminForm">
            <el-input v-model="addData.pic" placeholder="(仅用于人才战略)"></el-input>
          </el-form-item>
          <el-form-item label="在职人员" class="addAdminForm">
            <el-input v-model="addData.num1" placeholder="(仅用于人才战略)"></el-input>
          </el-form-item>
          <el-form-item label="研发人员" class="addAdminForm">
            <el-input v-model="addData.num2" placeholder="(仅用于人才战略)"></el-input>
          </el-form-item>
          <el-form-item label="生产基地" class="addAdminForm">
            <el-input v-model="addData.num3" placeholder="(仅用于人才战略)"></el-input>
          </el-form-item>
          <el-form-item label="详细内容">
            <VueUeditorWrap v-model="addData.content" :config="myConfig"></VueUeditorWrap>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="BackToFirst">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <el-tab-pane label="修改" name="second" disabled="disabled">
        <KgjtWebsiteTalentStrategyEdit ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></KgjtWebsiteTalentStrategyEdit>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import KgjtWebsiteTalentStrategyEdit from '@/componentsKgjt/KgjtWebsiteTalentStrategyEdit.vue'
import VueUeditorWrap from 'vue-ueditor-wrap'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    KgjtWebsiteTalentStrategyEdit,
    VueUeditorWrap
  },
  name: 'MyKgjtWebsiteTalentStrategy',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      tstypeList: [],
      // 查询客户
      keywords: {
        tstype: '0',
        title: ''
      },
      // 添加
      addData: {
        tstype: '',
        title: '',
        pic: '',
        num1: '',
        num2: '',
        num3: '',
        content: ''
      },
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 500,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口
        serverUrl: '',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/'
      }
    }
  },
  mounted () {
    this.tstypeList = Vue.prototype.FunGetTsType()
    this.GetKgjtWebsiteTalentStrategyNum()
    this.GetKgjtWebsiteTalentStrategyList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.GetKgjtWebsiteTalentStrategyList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.GetKgjtWebsiteTalentStrategyList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.GetKgjtWebsiteTalentStrategyNum()
      this.GetKgjtWebsiteTalentStrategyList()
    },
    clickadd () {
      this.AddKgjtWebsiteTalentStrategy()
    },
    // 修改
    goEdit (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row)
    },
    // 删除
    goDel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.DelKgjtWebsiteTalentStrategy(row)
      })
    },
    // 产品特点
    goPic (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData(row)
    },
    GetKgjtWebsiteTalentStrategyList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        tstype: that.keywords.tstype,
        title: that.keywords.title
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteTalentStrategyList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    GetKgjtWebsiteTalentStrategyNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        tstype: that.keywords.tstype,
        title: that.keywords.title
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteTalentStrategyNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    AddKgjtWebsiteTalentStrategy: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        tstype: that.addData.tstype,
        title: that.addData.title,
        pic: that.addData.pic,
        num1: that.addData.num1,
        num2: that.addData.num2,
        num3: that.addData.num3,
        content: that.addData.content
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddKgjtWebsiteTalentStrategy, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'

            that.addData.tstype = ''
            that.addData.title = ''
            that.addData.pic = ''
            that.addData.num1 = ''
            that.addData.num2 = ''
            that.addData.num3 = ''
            that.addData.content = ''

            that.GetKgjtWebsiteTalentStrategyNum()
            that.GetKgjtWebsiteTalentStrategyList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    DelKgjtWebsiteTalentStrategy: function (row) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: row.Id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelKgjtWebsiteTalentStrategy, Qs.stringify(data))
        .then(function (response) {
          that.GetKgjtWebsiteTalentStrategyNum()
          that.GetKgjtWebsiteTalentStrategyList()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
